import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  className?: string;
}

const CTASection: React.FC<CTASectionProps> = ({ className = '' }) => {
  return (
    <div className={`bg-gradient-to-br from-primary via-secondary to-primary rounded-lg p-8 md:p-12 text-center ${className}`}>
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-primary-foreground mb-4">
          Ready to Create Your Impact Story?
        </h2>
        <p className="text-lg text-primary-foreground/90 mb-8">
          Join 150+ organizations across India and UAE making measurable environmental impact. Let's discuss how GenCarbon can help you achieve your sustainability goals.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="/get-started"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-accent text-accent-foreground font-heading font-semibold text-lg rounded-lg hover:bg-accent/90 shadow-natural hover:shadow-natural-lg transition-all duration-300 transform hover:scale-102"
          >
            <span>Get Started Today</span>
            <Icon name="ArrowRightIcon" size={20} />
          </Link>

          <a
            href="mailto:dr.nupur@gencarbon.in"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-card text-text-primary font-heading font-semibold text-lg rounded-lg hover:bg-surface border-2 border-primary-foreground/20 transition-all duration-300"
          >
            <Icon name="EnvelopeIcon" size={20} />
            <span>Contact Dr. Nupur</span>
          </a>
        </div>

        <div className="mt-8 flex items-center justify-center gap-6 text-primary-foreground/80">
          <div className="flex items-center gap-2">
            <Icon name="CheckCircleIcon" size={20} variant="solid" />
            <span className="text-sm">Free Consultation</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="CheckCircleIcon" size={20} variant="solid" />
            <span className="text-sm">Expert Guidance</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="CheckCircleIcon" size={20} variant="solid" />
            <span className="text-sm">Proven Results</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;